import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Input } from "antd";

const Description = props => {
  const { isSave, onChange, requestBody } = props;
  const [descriptionError, setDescriptionError] = useState(false);
  
  const genericDescription = `${useIntl().formatMessage({ id: "generic.description" })} *`;

  useEffect(() => {       
    if (!isSave) setDescriptionError(false); 
    else setDescriptionError(!requestBody?.description?.title);
  }, [isSave]);

  let description = requestBody.description.title
    ? requestBody.description.title
    : undefined;

  return (
    <div className={descriptionError ? "errorOccurs" : ""} style={{width: "100%"}}>
      <div className="labelDialogContent">
        {genericDescription}
      </div>
      <div className="inputCustom">
        <Input
          value={description}
          onChange={onChange}
          placeholder={"Inserisci la descrizione della scadenza"}
        />
      </div>
    </div>
  );
};

export default Description;
